import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IParameters } from '@interfaces/parameters.interface';
import { IServiceOrder } from '@interfaces/service-order.interface';
import { Api } from '@root/core/constants/api-routes.constants.';
import { CONFIG } from '@root/core/constants/app.constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParametersService {

  server = CONFIG.API_SERVER;
  api = Api.PARAMS

  constructor(private httpClient: HttpClient) { }

  getAllVehicleReception(): Observable<IParameters[]> {
    const url = `${this.server}${this.api}/vehicle-reception`
    return this.httpClient.get<IParameters[]>(url)
  }
  getAllAuthorizations(): Observable<IParameters[]> {
    const url = `${this.server}${this.api}/authorizations`
    return this.httpClient.get<IParameters[]>(url)
  }
}
